import styled from '@pinecast/styles';
import * as React from 'react';

const Wrapper = styled('div', {
  display: 'flex',
  overflowX: 'auto',
  overflowY: 'hidden',
});
const Segment = styled(
  'div',
  (_, designColors) => ({
    flex: '0 0',
    ':not(:empty) + .SegmentedStats--Segment': {
      // borderLeft: `1px solid ${designColors.borderGrayNormal}`,
      marginLeft: 12,
      paddingLeft: 12,
    },
  }),
  {className: 'SegmentedStats--Segment'},
);
const Label = styled('span', (_, designColors) => ({
  color: designColors.contentText,
  display: 'block',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '16px',
  marginBottom: 0,
  whiteSpace: 'nowrap',
}));
const Value = styled('span', {
  display: 'block',
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '32px',
  whiteSpace: 'nowrap',
});

type Stat = {label: React.ReactNode; value: React.ReactNode};
type Props = {
  stats: Array<Stat | null | false | undefined>;
};

const SegmentedStats = ({stats}: Props) => {
  return (
    <Wrapper>
      {stats.map(
        (stat, i) =>
          stat && (
            <Segment key={i}>
              <Label>{stat.label}</Label>
              <Value>{stat.value}</Value>
            </Segment>
          ),
      )}
    </Wrapper>
  );
};

export default SegmentedStats;
